/* AMK: load the next collection page automatically when the visitor scrolls near the end. Pagination links stay in the HTML for crawlers. 2026-10-05 */
(function () {
  var grid = document.getElementById('product-grid');
  if (!grid || !('IntersectionObserver' in window) || !window.fetch) return;
  var loading = false;
  function wrapper() { return document.querySelector('.pagination-wrapper'); }
  function nextLink() { var w = wrapper(); return w && w.querySelector('a.pagination__item--prev[href]'); }
  var status = document.createElement('p');
  status.className = 'amk-loadmore visually-hidden';
  status.setAttribute('role', 'status');
  status.setAttribute('aria-live', 'polite');
  grid.insertAdjacentElement('afterend', status);
  function load() {
    var a = nextLink();
    if (!a || loading) return;
    loading = true;
    status.textContent = 'Henter flere produkter';
    fetch(a.href, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newGrid = doc.getElementById('product-grid');
        if (newGrid) {
          Array.prototype.forEach.call(newGrid.children, function (li) {
            grid.appendChild(document.importNode(li, true));
          });
        }
        var oldW = wrapper();
        var newW = doc.querySelector('.pagination-wrapper');
        if (oldW) {
          if (newW && newW.querySelector('a.pagination__item--prev[href]')) {
            oldW.replaceWith(document.importNode(newW, true));
          } else {
            oldW.remove();
          }
        }
        status.textContent = 'Flere produkter er vist';
        loading = false;
        observe();
      })
      .catch(function () { loading = false; });
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) load(); });
  }, { rootMargin: '800px 0px' });
  function observe() {
    io.disconnect();
    var w = wrapper();
    if (w && nextLink()) io.observe(w);
  }
  observe();
})();
